// Please note, this is case sensitive keys name , It's have to same with routing key
export const routeKeys = {
  home: 'Home',
  dashboard: 'Dashboard',
  tasksqueue: 'Tasks Queue',
  devices: 'Devices',
  sightings: 'Sightings',
  readers: 'Readers',
  equipments: 'Equipments',
  geofences: 'Geofences',
  facilities: 'Facilities',
  scansessions: 'Scan Sessions',
  monitoring: 'Monitoring',
  settings: 'Settings',
  labels: 'Labels',
  languages: 'Languages',
  manageInventory: 'Manage Inventory',
  SuperSentinelActivation: 'Super Sentinel Activation',
  report: 'Report',
  users: 'Users',
  collections: 'Collections',
  transfers: 'Transfers',
  templates: 'Templates',
  stockDetails: 'Stock Details',
  visits: 'Visits',
};
